import { css } from "@emotion/css";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import type { ReactNode } from "react";
import React, { useEffect, useRef } from "react";
import { useFocusTrap } from "../../hooks/useFocusTrap";
import { Portal } from "../Portal";
interface OverlayProps {
    children?: ReactNode;
    onClick?: () => void;
}
export function Overlay({ children, onClick }: OverlayProps) {
    const setFocusTrapElement = useFocusTrap();
    const divRef = useRef<HTMLDivElement>(null);
    const handleClick: React.MouseEventHandler = (event) => {
        if (event.target === divRef.current) {
            onClick?.();
        }
    };
    useEffect(() => {
        if (divRef.current) {
            setFocusTrapElement(divRef.current);
        }
    }, [setFocusTrapElement]);
    return (<Portal>
            <div role={"presentation"} aria-label={"overlay"} ref={divRef} onClick={handleClick} className={overlayStyles}>
                {children}
            </div>
        </Portal>);
}
const overlayStyles = css({
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: themeTokens.color.overlay.primary,
});
